import { Column } from '@dixa/lib-shared-habla';
import { memo } from 'react';

import { PartialChildren } from 'components/partialChildren';

import { ContactItem, ContactItemProps } from '../contactItem/contactItem';

import styles from './contactItems.module.scss';

export type ContactItemsProps = {
  /** The contact items to display. */
  items: ContactItemProps[];
  /** The maximum number of items to display initially. */
  limit: number;
  /** Whether this is the last section in the list. */
  isLast?: boolean;
};

export const ContactItems = memo(function ContactItems({
  items,
  limit,
  isLast,
}: ContactItemsProps): JSX.Element {
  return (
    <Column.Row noHorizontalPadding borderBottom={isLast}>
      <ul className={styles.contactItems}>
        <PartialChildren limit={limit}>
          {items.map((item, index) => (
            <ContactItem key={index} {...item} />
          ))}
        </PartialChildren>
      </ul>
    </Column.Row>
  );
});
